<template>
  <div class="flex" @click="toDownLoadPage">
    <img :src="$icons.file" class="flex0" alt="">
    <div class="ml10 content flex0 pr10">
      <h3 class="lines2">{{ info.attaFileName }}</h3>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {isAndroid, isAndroidBrower, isDevelopment, pick} from "@/lib/util";

export default {
  name: "file-section",
  filters: {
    sizeFilter(str) {
      if (!str) return;
      const DANWEIS = [1024, 1024 * 1024, 1024 * 1024 * 1024, 1024 * 1024 * 1024 * 1024];
      const danweis = ['KB', 'KB', "M", "G"];
      for (let i = 0; i < DANWEIS.length; i++) {
        const danwei = DANWEIS[i];
        if (str < danwei) {
          return `${(str / danwei).toFixed(2)}${danweis[i]}`;
        }
      }
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      size: ''
    }
  },
  mounted() {
    /*axios.get('https://api.limingwei.name/zheer/pdf?file=' + encodeURIComponent(this.info.url))
      .then(response => {
        Log('response.headers', response.headers);
        this.size = response.headers['content-length'];
      })*/
  },
  methods: {
    toDownLoadPage() {
      this.$router.push({
        path: '/team/download',
        query: pick({
          title: 'attaFileName',
          url: 'url',
          createTime: 'createTime'
        }, this.info)
      })
      /*if (isAndroid() || isDevelopment()) {
        location.href = './static/pdfjs/web/viewer.html?file=' + encodeURIComponent('https://api.limingwei.name/zheer/pdf?file=' + encodeURIComponent(this.info.url))
      } else {
        location.href = this.info.url;
      }*/
    }
  },
}
</script>

<style scoped lang="scss">
img {
  width: 42px;
  height: 55px;
}

.content {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/file-section.vue